module.exports = __webpack_public_path__ + "static/media/gobierno_white.2bdf7178.png";